<script>
    import BreadCrumbItem from './BreadCrumbItem';

    export default {
        name: 'bread-crumb',
        props: {
            type: {
                type: String,
                required: false,
                default: 'path'
            },
            separatorIcon: {
                type: String,
                default: '&#xe697;',
                required: false
            },
            paths: {
                type: Object,
                required: false
            },
            parent: {
                type: Object,
                required: false
            },
            root: {
                type: Object,
                required: false,
                default: function () {
                    return {
                        text: '目录',
                        path: '/'
                    };
                }
            }
        },
        provide () {
            return {
                breadCrumb: this
            };
        },
        data () {
            return {
                routePath: this.paths,
                currentPath: []
            };
        },
        watch: {
            $route () {
                if (this.$slots.default) {
                    return;
                }
                if (this.type === 'path') {
                    this.computeRoute();
                } else {
                    this.computeRouteByPathName();
                }
            },
            paths () {
                this.routePath = this.paths;
                if (this.type === 'path') {
                    this.computeRoute();
                } else {
                    this.computeRouteByPathName();
                }
            }
        },
        methods: {
            gotoPath (path) {
                this.$router.push(this.type === 'path' ? {
                    path: path
                } : {name: path});
            },
            computeRoute () {
                this.currentPath = [];
                if (this.parent) {
                    let flag = false;
                    if (this.parent && Object.keys(this.parent).length > 0) {
                        this.currentPath.push(this.parent);
                        flag = true;
                    }
                    if (!this.$route) {
                        return;
                    }
                    let curRoute = this.$route.path;
                    let curRouteObj = this.routePath[curRoute];
                    if (!curRouteObj) {
                        return;
                    }
                    for (let key in this.routePath) {
                        if (this.routePath.hasOwnProperty(key) && ((!flag && curRoute.indexOf(key) === 0)) || (flag && curRoute === key)) {
                            curRouteObj = this.routePath[key];
                            curRouteObj.path = curRoute;
                            this.currentPath.push(curRouteObj);
                        }
                    }
                    while (curRouteObj.parent) {
                        if (curRouteObj.parent) {
                            let parent = curRouteObj.parent;
                            curRouteObj = this.routePath[parent];
                            curRouteObj.path = parent;
                        }
                    }
                } else {
                    this.computeRouteByPathName(this.type);
                }

            },
            computeRouteByPathName (type) {
                this.currentPath = [];
                const {paths, $route} = this;
                if (!$route) {
                    return;
                }
                let {name} = $route;
                if (type) {
                    name = $route.path;
                }
                let curPath = paths[name];
                this.currentPath.unshift({path: name, text: curPath['text']});
                while (curPath && curPath.parent) {
                    curPath = paths[curPath.parent];
                    if (curPath) {
                        this.currentPath.unshift({
                            path: curPath.parent,
                            text: curPath.text
                        });
                    }
                }
            }
        },
        mounted () {
            if (!this.$slots.default) {
                process.nextTick(() => {
                    if (this.type === 'path') {
                        this.computeRoute();
                    } else if (this.type === 'pathName') {
                        this.computeRouteByPathName();
                    }
                });
            }
        },
        components: {
            BreadCrumbItem
        }
    };
</script>

<template>
    <div class="bread-crumb-wrapper">
        <template v-if="$slots.default">
            <slot></slot>
        </template>
        <template v-else-if="type === 'path'">
            <bread-crumb-item :to="root.path">{{ root.text }}</bread-crumb-item>
            <bread-crumb-item :key="key"
                              :to="item.path"
                              v-for="(item,key) in currentPath">{{item.text}}
            </bread-crumb-item>
        </template>
        <template v-else-if="type === 'pathName'">
            <bread-crumb-item :key="key"
                              :toName="item.path"
                              v-for="(item,key) in currentPath">{{item.text}}
            </bread-crumb-item>
        </template>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .bread-crumb-wrapper{
        color: @otherNormalTitleClr;
    }

    .path-pair {
        width: auto;
        min-width: 1px;
        overflow: hidden;
        float: left;
    }

    .path-arrow {
        width: 20px;
        line-height: 36px;
        height: 36px;
        font-size: 12px;
        text-align: center;
        float: left;
        color: @otherTextClr;
        font-family: cmsicon;
    }
</style>
